import styled from '@emotion/styled'
import { MultilingualKeyDto } from '@pharmac-extranet/management-api'
import { PharmacCheckbox, PharmacContainer, PharmacLabel } from '@pharmac/ui'
import { Control, Controller, FieldValues, Message, ValidationRule } from 'react-hook-form'
import { useLanguage } from '../../hooks'

const Checkbox = styled(PharmacCheckbox)`
  width: fit-content;

  input {
    width: 24px;
  }
`

const CheckboxRow = styled.div<{ flexColumn?: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.flexColumn ? 'column' : 'row')};
`

const CheckboxContainer = styled(PharmacContainer)`
  margin-bottom: var(--spacing-small);
`

type ControllerRules = {
  required?: Message | ValidationRule<boolean>
  min?: ValidationRule<number | string>
  max?: ValidationRule<number | string>
  maxLength?: ValidationRule<number>
  minLength?: ValidationRule<number>
}

type ControlledCheckboxesOption = {
  value: number | string
  name: MultilingualKeyDto
}

type ControlledCheckboxesProps = {
  data?: ControlledCheckboxesOption[]
  control?: Control<FieldValues>
  rules?: ControllerRules
  label?: string
  name: string
  column?: boolean
  checkboxLabel?: string
}

export const ControlledCheckboxes = (props: ControlledCheckboxesProps) => {
  const { key } = useLanguage()

  const handleCheckboxChange = (selectedValues: (number | string)[], value: number | string) => {
    return selectedValues.find((a) => a === value)
      ? selectedValues.filter((a) => a !== value)
      : selectedValues.concat(value)
  }

  const isRequired = !!props.rules && !!props.rules.required

  return (
    <>
      {!!props.label && (
        <PharmacLabel marginSmallBottom>
          {props.label} {isRequired && '*'}
        </PharmacLabel>
      )}
      <Controller
        name={props.name}
        control={props.control}
        rules={{ required: isRequired }}
        render={({ field: { ref, ...f } }) => (
          <CheckboxRow flexColumn={props.column}>
            {props.data?.map((item) => (
              <CheckboxContainer key={item.value}>
                <Checkbox
                  key={item.value}
                  marginLargeRight
                  checked={f.value?.includes(item.value)}
                  handleChange={() => f.onChange(handleCheckboxChange(f.value, item.value))}
                >
                  {props.checkboxLabel ? <>{props.checkboxLabel}</> : <>{key(item.name)}</>}
                </Checkbox>
              </CheckboxContainer>
            ))}
          </CheckboxRow>
        )}
      />
    </>
  )
}
